module.exports = __webpack_public_path__ + "static/JudyGaman2-686f9be267a40c1f2a285ff4cfa38d9a.jpg";